import React from 'react';
import InfiniteScrollCards from '@/components/cards/InfiniteScrollCards';
import RoleCardItems from '../containers/RoleCardItems';

const RoleCards = ({
  canCreate,
  category,
  handleScroll,
  items,
  itemsPerRow,
  newRole,
  readErrors,
  readStatus,
}) => (
  <InfiniteScrollCards
    canCreate={canCreate}
    className="aridhia-role-cards"
    entity="role"
    handleScroll={handleScroll}
    icon="drivers license"
    items={items}
    itemsPerRow={itemsPerRow}
    loading
    readErrors={readErrors}
    readStatus={[readStatus]}
    onClick={newRole}
  >
    <RoleCardItems category={category} items={items} />
  </InfiniteScrollCards>
);

export default RoleCards;
